import { RefObject, useEffect, useRef, useState } from 'react';

const DEFAULT_ROOT_MARGIN = '200px 0px';

export function useLazyLoadWhenVisible<T extends Element = HTMLDivElement>(
  rootMargin = DEFAULT_ROOT_MARGIN,
): { ref: RefObject<T>; hasBeenVisible: boolean } {
  const ref = useRef<T>(null);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || hasBeenVisible) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasBeenVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold: 0 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [hasBeenVisible, rootMargin]);

  return { ref, hasBeenVisible };
}
